import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORAGE_KEY = "promill_cart_v1";

const readInitial = () => {
    if (typeof window === "undefined") return [];
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
};

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(readInitial);

    useEffect(() => {
        try {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        } catch {
            // ignore
        }
    }, [items]);

    const addItem = (item) => {
        setItems((cur) => {
            const existing = cur.find((i) => i.id === item.id);
            if (existing) {
                return cur.map((i) => (i.id === item.id ? { ...i, qty: i.qty + 1 } : i));
            }
            return [...cur, { ...item, qty: 1 }];
        });
        toast.success(`Added ${item.name} to cart`);
    };

    const removeItem = (id) => setItems((cur) => cur.filter((i) => i.id !== id));

    const updateQty = (id, qty) =>
        setItems((cur) =>
            qty <= 0 ? cur.filter((i) => i.id !== id) : cur.map((i) => (i.id === id ? { ...i, qty } : i))
        );

    const clear = () => setItems([]);

    const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
    const count = items.reduce((s, i) => s + i.qty, 0);

    return (
        <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, subtotal, count }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be used inside CartProvider");
    return ctx;
};
